import FilterStore from "../../../hooks/customHook/FilterStore";

// One entry per sidebar page that SubjectAccounts.jsx serves. Everything that
// used to differ between the four copied pages (account-list1, assetaccount-list1,
// Liabilities1, OwnersEquity) lives here, so the page itself stays generic.
//
// module_type      - value stored on account_list_base_subs / sent to the API
// permission       - prefix of the Roles authrztn keys (<prefix>-View/Add/Edit/Delete)
// listUrl/subjectParam - Subject 3 endpoint and the query name it expects
// viewPath/viewState   - where the eye button goes (view-account-list1.jsx)
// lockedSubjectId  - seeded Subject 2 (masterlist.route.js) that can't be edited/deleted
// filter           - FilterStore getters/setters so each page keeps its own retention
export const SUBJECT_ACCOUNT_TYPES = {
  accountList: {
    title: "Account List",
    description: "Bank and cash accounts grouped by Subject 2",
    icon: "fa-building-columns",
    moduleType: "Account-List",
    permission: "AccountingList",
    listUrl: "/accountListSub/getSubject3ForFilter",
    subjectParam: "subjectId",
    viewPath: "/accounts/view-accountlist",
    viewState: { accList: true },
    lockedSubjectId: null,
    showForexGainLoss: true,
    isEquity: false,
    filter: {
      getSearch: () => FilterStore.ALgetSearch(),
      saveSearch: (v) => FilterStore.ALsaveSearch(v),
      getPage: () => FilterStore.ALgetPage(),
      savePage: (v) => FilterStore.ALsavePage(v),
      getPerPage: () => FilterStore.ALgetPerPage(),
      savePerPage: (v) => FilterStore.ALsavePerPage(v),
    },
  },
  asset: {
    title: "Asset Account",
    description: "Asset accounts grouped by Subject 2",
    icon: "fa-boxes-stacked",
    moduleType: "Asset Account",
    permission: "AssetAccount",
    listUrl: "/accountListSub/getSubject3ForFilter",
    subjectParam: "subjectId",
    viewPath: "/accounting/view-assetAccount",
    viewState: undefined,
    lockedSubjectId: "22222222-2222-2222-2222-222222222222",
    showForexGainLoss: false,
    isEquity: false,
    filter: {
      getSearch: () => FilterStore.AALgetSearch(),
      saveSearch: (v) => FilterStore.AALsaveSearch(v),
      getPage: () => FilterStore.AALgetPage(),
      savePage: (v) => FilterStore.AALsavePage(v),
      getPerPage: () => FilterStore.AALgetPerPage(),
      savePerPage: (v) => FilterStore.AALsavePerPage(v),
    },
  },
  liability: {
    title: "Liability Account",
    description: "Liability accounts grouped by Subject 2",
    icon: "fa-file-invoice-dollar",
    moduleType: "Liabilities Account",
    permission: "Liability",
    listUrl: "/accountListSub/getSubject3ForFilter",
    subjectParam: "subjectId",
    viewPath: "/accounting/view-liabilityAccount",
    viewState: undefined,
    lockedSubjectId: "33333333-3333-3333-3333-333333333333",
    showForexGainLoss: false,
    isEquity: false,
    filter: {
      getSearch: () => FilterStore.LgetSearch(),
      saveSearch: (v) => FilterStore.LsaveSearch(v),
      getPage: () => FilterStore.LgetPage(),
      savePage: (v) => FilterStore.LsavePage(v),
      getPerPage: () => FilterStore.LgetPerPage(),
      savePerPage: (v) => FilterStore.LsavePerPage(v),
    },
  },
  equity: {
    title: "Owners' Equity Account",
    description: "Owner investments and their shared percentage",
    icon: "fa-handshake",
    moduleType: "Owner's Equity Account",
    permission: "Equity",
    listUrl: "/accountListSub/getSubject3OwnerEquity",
    subjectParam: "subject2Id",
    viewPath: "/accounting/view-equityAccount",
    viewState: undefined,
    lockedSubjectId: "11111111-1111-1111-1111-111111111111",
    showForexGainLoss: false,
    // Adds Investment Amount + Shared Percentage columns, the investment
    // input on create and the edit (rename) modal
    isEquity: true,
    filter: {
      getSearch: () => FilterStore.OEgetSearch(),
      saveSearch: (v) => FilterStore.OEsaveSearch(v),
      getPage: () => FilterStore.OEgetPage(),
      savePage: (v) => FilterStore.OEsavePage(v),
      getPerPage: () => FilterStore.OEgetPerPage(),
      savePerPage: (v) => FilterStore.OEsavePerPage(v),
    },
  },
};
